import * as Common from '@/tenant/common';

export class Segment extends Common.MasterBase{
  constructor(){
    super('Segment');
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public id: number = 0;
  public code: string = '';
  public name: string='';
  public companyName: string = '';
  public mappingCode: string = '';
  public signer: string = '';
  public postalCode: string = '';
  public address1: string = '';
  public address2: string = '';
  public address3: string = '';
  public telNo: string = '';
  public faxNo: string = '';
  public globalCode: string = '';
  public corporateNo: string = '';
  public companyNameInv: string = '';
  public segmentnameInv: string = '';
  public addressInv1: string = '';
  public addressInv2: string = '';
  public addressInv3: string = '';
  public manager: string = null;
  public payerSegmentId: number = null;
  public payerSegment: Segment = null;

  // 税区分設定
  public taxSalesExclusive: string = null;
  public taxSalesInclusive: string = null;
  public taxSalesNontarget: string = null;
  public taxPurchaseExclusive: string = null;
  public taxPurchaseInclusive: string = null;
  public taxPurchaseNontarget: string = null;
  
  // 初期設定
  public priceCalculationMethod: PricingTypes = 0;
  public priceCalculationKey: PricingKeyTypes = 0;
  public stockControlProjectFlag:boolean = false;
  public exchangeRateScale: number = 0;
  public quantityScale: number = 0;
  public quantityRound: Common.RoundTypes = Common.RoundTypes.RoundMidpoint;
  public priceScaleSystemCurrency: number = 0;
  public priceScaleOtherCurrency: number = 0;
  public stockPriceScale: number = 0;
  public stockPriceRound: Common.RoundTypes = Common.RoundTypes.RoundMidpoint;
  public skuStockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveText1StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveText2StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveText3StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveText4StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveText5StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveText6StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveMemo1StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveMemo2StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveMemo3StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveDate1StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveDate2StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveDate3StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveList1StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveList2StockAttribute: Common.StockTypes = Common.StockTypes.None;
  public reserveList3StockAttribute: Common.StockTypes = Common.StockTypes.None;

  // 部門区分
  public segmentCategory1: number = null;
  public segmentCategory2: number = null;
  public segmentCategory3: number = null;
  public segmentCategory4: number = null;
  public segmentCategory5: number = null;
  public segmentCategory6: number = null;

  // 会社ロゴ情報
  public fileId: number = null;
  public fileName: string = null;
  // 会社印情報
  public stampFileId: number = null;
  public stampFileName: string = null;

  public closingDate: Date = null;

  public copy():any {
    const temp = super.copy() as Segment;
    temp.id = 0;
    temp.code = null;    
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    temp.closingDate = null;
    temp.fileId = null;
    temp.fileName = null;
    temp.stampFileName = null;
    temp.stampFileId = null;
    return temp;
  }
}

export enum PricingTypes {
  MonthlyAverage = 0,
  MovingAverage = 1,
  LastPurchase = 2,
  Specific = 3,
}

export enum StockTypes {
  None = 0,
  Balance = 1,
  Price = 3,
  Location = 5,
}
export enum PricingKeyTypes
{
    ByCommodityBySKU = 0,
    ByCommodity = 1,
}
export class StockTypesFilter{
  public static getStockTypes(withPrice:boolean = true, withPlace:boolean = true){
    var stockTypes:Array<Common.BindItem> = [new Common.BindItem(Common.StockTypes.None, '(未指定)'),new Common.BindItem(Common.StockTypes.Balance, '数量')];
    if(withPrice) stockTypes.push(new Common.BindItem(Common.StockTypes.Price, '単価'));
    if(withPlace) stockTypes.push(new Common.BindItem(Common.StockTypes.Location, '配置'));
    return stockTypes;
  }
}

export class SegmentQuery extends Common.LoadQuery {
  constructor(){
    super('SegmentQuery',Segment);
    this.sort = 'code';
  }

  public code: string = '';
  public companyName: string = '';
  public name: string = '';
  public segmentCategory1: number = null;
  public segmentCategory2: number = null;
  public segmentCategory3: number = null;
  public segmentCategory4: number = null;
  public segmentCategory5: number = null;
  public segmentCategory6: number = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export class SegmentMasterQuery extends Common.LoadQuery {
  constructor(){
    super('SegmentMasterQuery',Segment);
  }
}

export class SegmentImportQuery extends Common.ImportQuery {
  constructor(sheetName:string){
    super("",null);
    this.className = "SegmentImportQuery";
    this.sheetName = sheetName;
    this.hasLicenseTrade = false;
  }
  public sheetName: string;
  public hasLicenseTrade: boolean;
}

export class SegmentExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "SegmentExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.hasLicenseTrade = false;
  }
  public loadQuery: Common.LoadQuery;
  public sheetName: string;
  public hasLicenseTrade: boolean;
}

export class StockPostQuery extends Common.Query {
  constructor(){
    super('StockPostQuery',new Common.ModelBinder(Segment,false));
  }
  public closingDate: Date;
  public segment: Common.Segment;
}

export class StockUnPostQuery extends Common.Query {
  constructor(){
    super('StockUnPostQuery',new Common.ModelBinder(Segment,false));
  }
  public closingDate: Date;
  public segment: Common.Segment;
}
export class DeleteSegmentQuery extends Common.Query {
  constructor(){
    super('DeleteSegmentQuery',new Common.ModelBinder(Segment,false));
  }
  public segment: Common.Segment;
  // public replacementSegment: Common.Segment;
}
export class CompanyFileUploadQuery extends Common.Query {
  constructor(){
    super('CompanyFileUploadQuery',null);
  }
  public parentKey:string = '';
  public parentId:string='';    
  public timestamps :string='';
  public description:string='';
  public tag:string = null;
  public uploadPIC:string='';
  public segment: Common.Segment;
  public imageSourceFlag:Common.ImageSourceFlags;
}
export class CompanyFileDownloadQuery extends Common.Query{
  constructor(){
    super('CompanyFileDownloadQuery',null);
  }
  public fileId:number = 0;
}
export class CompanyFileDeleteQuery extends Common.Query{
  constructor(){
    super('CompanyFileDeleteQuery',null);
  }
  public segment:Common.Segment;
  public imageSourceFlag:Common.ImageSourceFlags;
}